import React from "react";
import "./styles/MenuActions.css";

function MenuActions() {
  return (
    <div className="actions--container">
      <button className="actions--reset">Reset</button>
      <button className="actions--apply">Apply</button>
    </div>
  );
}

export default MenuActions;
